import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import type { DrawerNode } from '../drawer.types';
type UseNestedLevelProps = {
  rootIsOpen: boolean;
  onBack: () => void;
  onCloseAll: () => void;
};
export function useNestedLevel(t0) {
  const $ = _c(15);
  const {
    rootIsOpen,
    onBack,
    onCloseAll
  } = t0;
  const [activeNode, setActiveNode] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const activeTriggerRef = useRef(null);
  const isBackNavigationRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== rootIsOpen) {
    t1 = () => setIsOpen(rootIsOpen);
    t2 = [rootIsOpen];
    $[0] = rootIsOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (nextNode, trigger) => {
      activeTriggerRef.current = trigger;
      setActiveNode(nextNode);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const openNode = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setActiveNode(null);
      requestAnimationFrame(() => activeTriggerRef.current?.focus());
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const closeChild = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      isBackNavigationRef.current = true;
      setIsOpen(false);
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleBack = t5;
  let t6;
  if ($[6] !== onCloseAll) {
    t6 = nextIsOpen => {
      setIsOpen(nextIsOpen);
      if (!nextIsOpen && !isBackNavigationRef.current) {
        onCloseAll();
      }
    };
    $[6] = onCloseAll;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleOpenChange = t6;
  let t7;
  if ($[8] !== onBack) {
    t7 = isNowOpen => {
      if (isNowOpen) {
        return;
      }
      if (isBackNavigationRef.current) {
        isBackNavigationRef.current = false;
        onBack();
      }
    };
    $[8] = onBack;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleOpenChangeComplete = t7;
  let t8;
  if ($[10] !== activeNode || $[11] !== handleOpenChange || $[12] !== handleOpenChangeComplete || $[13] !== isOpen) {
    t8 = {
      activeNode,
      closeChild,
      handleBack,
      handleOpenChange,
      handleOpenChangeComplete,
      isOpen,
      openNode
    };
    $[10] = activeNode;
    $[11] = handleOpenChange;
    $[12] = handleOpenChangeComplete;
    $[13] = isOpen;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}